import { render, staticRenderFns } from "./TextRow.vue?vue&type=template&id=645d6b74&"
import script from "./TextRow.ts?vue&type=script&lang=ts&"
export * from "./TextRow.ts?vue&type=script&lang=ts&"
import style0 from "./TextRow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports